export const getValue = (obj, paths) => {
  // Handle null/undefined object
  if (!obj || !paths || paths.length === 0) {
    return null;
  }

  try {
    if (paths.length > 1) {
      const removed = paths.shift();
      const nextObj = obj[removed];
      if (nextObj === undefined || nextObj === null) {
        return null;
      }
      return getValue(nextObj, paths);
    } else {
      const key = paths[0];
      const value = obj[key];
      
      if (value === undefined) {
        return null;
      }
      
      if (key === 'vehicle' && value && typeof value === 'object') {
        // Special formatting for vehicle objects
        const year = value.year || 'undefined';
        const make = value.make || 'undefined';
        const model = value.model || 'undefined';
        const vin = value.vin || 'undefined';
        return `${year} ${make} ${model}  VIN: ${vin}`;
      } else {
        return value === null ? null : value;
      }
    }
  } catch {
    return null;
  }
};

export const parsePathDashed = (objectToParse, pathDash) => {
  // Handle null/undefined object or empty path
  if (!objectToParse || !pathDash || pathDash === '') {
    return null;
  }

  const pathArray = pathDash.split('__');
  
  // If any element is empty (from consecutive underscores), return null
  if (pathArray.some(path => path === '')) {
    return null;
  }
  
  if (pathArray.length === 0) {
    return null;
  }

  // Create a copy of the paths array to avoid mutating the original
  return getValue(objectToParse, [...pathArray]);
};
